var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-recaptcha',{ref:"reCaptcha",class:[_vm.isShake ? 'shake' : ''],staticStyle:{"user-select":"none"},attrs:{"sitekey":_vm.reCaptchaKey,"loadRecaptchaScript":true},on:{"verify":_vm.verifyMethod,"expired":_vm.expiredMethod}})}
var staticRenderFns = []

export { render, staticRenderFns }